import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { MARKETING_PLUS_ENTERPRISE_BUNDLE, MARKETING_PLUS_PROFESSIONAL_BUNDLE } from 'self-service-api/constants/ApiNames';
import { MARKETING_PLUS_SUITE } from 'self-service-api/constants/BundleTypes';
import { MARKETING_PLUS_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { default as ProductTile } from '../merch-card/ProductTile';
import ProductTiles from '../merch-card/ProductTiles';
import { jsx as _jsx } from "react/jsx-runtime";
const MARKETING_PLUS_PRODUCTS = [MARKETING_PLUS_PROFESSIONAL_BUNDLE, MARKETING_PLUS_ENTERPRISE_BUNDLE];
export const MarketingPlusTiles = ({
  screen
}) => {
  const isAppReady = useGlobalLoading();
  if (!isAppReady) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }
  return /*#__PURE__*/_jsx(ProductTiles, {
    columns: MARKETING_PLUS_PRODUCTS.length,
    children: MARKETING_PLUS_PRODUCTS.map((apiName, index) => {
      return /*#__PURE__*/_jsx(ProductTile, {
        apiName: apiName,
        gridItemProps: {
          gridColumnStart: index + 1,
          paddingInline: '700'
        },
        screen: screen,
        trackingSource: MARKETING_PLUS_CARD
      }, `${MARKETING_PLUS_SUITE}-${apiName}`);
    })
  });
};
export default MarketingPlusTiles;